import { curry, fromPairs, map, adjust, toPairs } from 'ramda';

export const mapObjectKeys = curry((fn, obj) =>
    fromPairs(map(adjust(0, fn), toPairs(obj))));
